<template>
  <div class="brazil-checkbox-field">
    <label
      :for="inputId"
      class="check_box"
    >
      <input
        :id="inputId"
        v-model="validatorField.$model"
        type="checkbox"
        :class="status"
        :disabled="disabled"
        :true-value="trueValue"
        :false-value="falseValue"
        @change="$emit('change', true)"
      >

      <div :class="wrapperClass">
        <div
          v-if="label !== ''"
          :class="labelClass"
          v-html="label"
        />
        <slot
          v-else
          name="label"
        />
        <slot name="icon" />
      </div>
    </label>
    <brazil-error-label :validator-field="validatorField" />
  </div>
</template>
<script>
import BrazilErrorLabel from './BrazilErrorLabel.vue';

export default {
  components: {
    BrazilErrorLabel,
  },
  props: {
    name: {
      type:     String,
      required: true,
    },
    inputId: {
      type:     String,
      required: true,
    },
    label: {
      type:    String,
      default: '',
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    trueValue: {
      type:    [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: true,
    },
    falseValue: {
      type:    [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: false,
    },
    checked: {
      type:    Boolean,
      default: false,
    },
    labelClass: {
      type:    String,
      default: '',
    },
    wrapperClass: {
      type:    String,
      default: '',
    },
    disabled: {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    status() {
      return {
        valid: this.validatorField.$dirty && !this.validatorField.$error,
        error: this.validatorField.$error,
      };
    },
  },
  created() {
    const initialValue = this.checked ? this.trueValue : this.falseValue;
    this.validatorField.$model = initialValue;
    this.validatorField.$reset();
  },
};
</script>
<style lang="scss" scoped>
  .brazil-checkbox-field {
    display: block;
    color: #333333;
    label, input {
      &:hover {
        cursor: pointer;
      }
    }
  }
  label {
    display: flex;

    input {
      margin-right: 1em;
    }
  }
</style>
